module.exports = __webpack_public_path__ + "static/AutoPolicyUpdatesMobile-66e9985a2807fa5ce473b6389538a5f9.webp";